import React, { Component } from 'react';
import './questions-list.scss';
import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import CwContentViewer from '../../../common/cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../../../common/canvas/canvas'
import GeometryTranspiler from '../../../common/geometry/geometry-parser'

class QuestionList extends Component {

    state = {
    }

    componentDidMount() {
    }



    onClickBack = () => {
        this.props.back()
    }


    renderList = () => {
        return (
            this.props.contents?.map((skill, index) => (

                <div className="concept-wrapper">
                    <div className="concept-title pt-2">{skill?.skill}</div>
                    <div >
                        {
                            skill.questions.map((question, qnIndex) => (
                                <div className='row pt-4 flex-no-wrap ' >
                                    <div className='col-1 ml-0 elo-index pr-0'>{`Q${qnIndex + 1}`}</div>
                                    <div className='col'>
                                        <div className='qn-title'><CwContentViewer content={question.content.title} /></div>
                                        {question.content.images.length ? question.content.images.map((image, imageIndex) =>
                                            <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                                        )
                                            :
                                            ""}

                                    </div>
                                </div>
                            ))

                        }
                    </div>
                </div>
            ))
        )
    }

    render() {
        return (
            <div className='question-detail'>

                <div className="abs-image">
                    <img className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                </div>

                <div className="pt-4 my-auto text-right"><img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={this.onClickBack.bind(this)} /></div>
                <div className='mt-4 qs-font-weight'>Questions</div>
                <div className='mt-3 apx-time-size'>
                <span className=""><span><span>Total Qs. Selected : </span> <b className="pl-1"> {this.props.questionCount || 0}</b></span></span>
                                    <span className="p-2 ml-5"><span><span>Estimated Time : </span> <b className="pl-1">{this.props.approximateTime || 0} </b>mins</span></span>
                                    
                </div>
                <div className='qs-border mt-4'></div>
                <div>
                    {this.renderList()}
                </div>
            </div >
        );
    }
}

export default QuestionList;